<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>基础数据</span>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="uid"
        label="UID"
        align="center"
      />
      <el-table-column
        prop="reg_date"
        label="注册日期"
        align="center"
      />
      <el-table-column
        prop="log_date"
        label="登录日期"
        align="center"
      />
      <el-table-column
        prop="level"
        label="关卡等级"
        align="center"
      />
      <el-table-column
        prop="spins"
        label="体力"
        align="center"
      >
        <template v-slot:default="scope">
          <a class="underline" href="javascript:;" @click="queryMoney(scope.row.uid,15)">{{ scope.row.spins }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="money"
        label="金币"
        align="center"
      >
        <template v-slot:default="scope">
          <a class="underline" href="javascript:;" @click="queryMoney(scope.row.uid,14)">{{ scope.row.money }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="beast_coin"
        label="野兽币"
        align="center"
      >
        <template v-slot:default="scope">
          <a class="underline" href="javascript:;" @click="queryMoney(scope.row.uid,65)">{{ scope.row.beast_coin }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="diamond"
        label="钻石"
        align="center"
      >
        <template v-slot:default="scope">
          <a class="underline" href="javascript:;" @click="queryMoney(scope.row.uid,22)">{{ scope.row.diamond }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="star"
        label="星星"
        align="center"
      />
    </el-table>
  </el-card>
</template>

<script>
import { getSlotDataList } from '@/api/config/robot'

export default {
  name: 'BotTable',
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getSlotDataList().then(res => {
        this.tableData = res.data
      })
    },
    queryMoney(uid, type) {
      this.$router.push({ name: 'CurrencySources', query: { uid: uid, type: type }})
    }
  }
}
</script>

<style scoped>
.underline{
  color: #0e6cff;
  text-decoration:underline;
  text-underline: #1c84c6;
}
</style>
